module.exports = __webpack_public_path__ + "assets/img/gift-2-956dab10.png";